// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomerTypeSwitcher_wrapper__kKimf"};